import config from '@plone/registry';
import { Container as SemanticContainer } from 'semantic-ui-react';
import FooterLinks from '@redturtle/qubicaamf-theme/components/Footer/FooterLinks';
import FirstSubfooter from './firstsubfooter';
import SecondSubFooter from './secondsubfooter';

export default function Footer() {
  const Container =
    config.getComponent('Container').component || SemanticContainer;
  return (
    <footer role="contentinfo" id="footer" aria-label="Footer">
      <Container>
        <FooterLinks />
        <FirstSubfooter />
        <SecondSubFooter />
      </Container>
    </footer>
  );
}
